import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "../../assets/css/vendors/HotelComponents/modalBooking.css";

const ModalBooking = ({
  show,
  handleClose,
  booking,
  mode,
  loading,
  onSave,
}) => {
  const [hotelRooms,     setHotelRooms]     = useState([]);
  const [bookingStatus,  setBookingStatus]  = useState("");
  const [selectedRoomId, setSelectedRoomId] = useState("");

  useEffect(() => {
    if (booking && mode === "edit") {
      setBookingStatus(booking.booking_status || "");
      if (booking.jjroom_id) {
        setSelectedRoomId(booking.jjroom_id);
      } else {
        const firstRoom = booking?.jjvendor?.jjhotelregistration?.jjrooms?.[0];
        setSelectedRoomId(firstRoom?.id || "");
      }
      const rooms = (booking?.jjvendor?.jjhotelregistration?.jjrooms || [])
        .filter(room => room.status?.toLowerCase() === "available");
      setHotelRooms(rooms);
    }
  }, [booking, mode]);

  const formatDate = (d) => {
    if (!d) return "N/A";
    return new Date(d).toLocaleDateString("en-US", {
      year: "numeric", month: "long", day: "numeric", timeZone: "UTC",
    });
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      className="mbooking-custom-modal"
    >
      {mode === "edit" && (
        <>
          <Modal.Header closeButton className="mbooking-modal-header">
            <Modal.Title className="mbooking-title">Edit Booking</Modal.Title>
          </Modal.Header>

          <Modal.Body className="mbooking-modal-body">

            <div className="mbooking-info-box">
              <p className="mbooking-info-item">
                <strong className="mbooking-info-label">Guest:</strong>
                <span className="mbooking-info-value">
                  {booking?.jjcustomer?.cus_username || "N/A"}
                </span>
              </p>
              <p className="mbooking-info-item">
                <strong className="mbooking-info-label">Check-In:</strong>
                <span className="mbooking-info-value">
                  {formatDate(booking?.checkIn)}
                </span>
              </p>
              <p className="mbooking-info-item">
                <strong className="mbooking-info-label">Check-Out:</strong>
                <span className="mbooking-info-value">
                  {formatDate(booking?.checkOut)}
                </span>
              </p>
            </div>

            <div className="mbooking-form-group">
              <Form.Label className="mbooking-form-label">Booking Status</Form.Label>
              <Form.Select
                value={bookingStatus}
                onChange={(e) => setBookingStatus(e.target.value)}
                className="mbooking-form-select"
                required
              >
                <option value="">Select Status</option>
                <option value="confirmed">Confirmed</option>
                <option value="pending">Pending</option>
                <option value="cancelled">Cancelled</option>
                <option value="completed">Completed</option>

              </Form.Select>
            </div>

            <div className="mbooking-form-group">
              <Form.Label className="mbooking-form-label">Room Number</Form.Label>
              <Form.Select
                value={selectedRoomId}
                onChange={(e) => setSelectedRoomId(e.target.value)}
                className="mbooking-form-select"
                required
              >
                <option value="">Select Room</option>
                {hotelRooms.map((room) => (
                  <option key={room.id} value={room.id}>
                    Room {room.room_number} — {room.room_type} ({room.status})
                  </option>
                ))}
              </Form.Select>
            </div>

          </Modal.Body>

          <Modal.Footer className="mbooking-modal-footer">
            <Button
              variant="secondary"
              onClick={handleClose}
              className="mbooking-cancel-btn"
            >
              Cancel
            </Button>
            <Button
              disabled={loading}
              className="mbooking-save-btn"
              onClick={() => onSave({
                booking_id:     booking?.id,
                booking_status: bookingStatus,
                room_id:        selectedRoomId,
              })}
            >
              {loading ? "Saving..." : "Update Booking"}
            </Button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

export default ModalBooking;